import { render, staticRenderFns } from "./PaymentCreator.vue?vue&type=template&id=284df9c2&scoped=true&"
import script from "./PaymentCreator.vue?vue&type=script&lang=js&"
export * from "./PaymentCreator.vue?vue&type=script&lang=js&"
import style0 from "./PaymentCreator.vue?vue&type=style&index=0&id=284df9c2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "284df9c2",
  null
  
)

export default component.exports